/**
 * LOINC codes for colorectal cancer screening observations
 * Source: obs_2026-04-21-1046.csv
 * Excludes: 62959-2 (PhenX research survey instrument, not a clinical screening observation)
 */
export const COLORECTAL_CANCER_SCREENING_LOINC_CODES = [
  "18746-8", // Colonoscopy study
  "77353-1", // Noninvasive colorectal cancer DNA and occult blood screening [Interpretation] in Stool Narrative
  "77354-9", // Noninvasive colorectal cancer DNA and occult blood screening [Presence] in Stool
];

/**
 * SNOMED CT codes for colorectal cancer screening procedures
 * Excludes: referrals, therapeutic/interventional colonoscopy variants, pathology
 * procedures, findings, qualifier values, situations, and unrelated procedures
 */
export const COLORECTAL_CANCER_SCREENING_SNOMED_CODES = [
  // --- Stool-based tests ---
  "104434000", // Gastrointestinal occult blood test (procedure)
  "104435004", // Screening for occult blood in feces (procedure)
  "144895007", // Occult blood screening - feces (procedure)
  "442516004", // Measurement of occult blood in three separate stool specimens (procedure)
  "442554004", // Guaiac test for occult blood in feces specimen (procedure)
  "442563002", // Measurement of occult blood in single stool specimen (procedure)
  "457591000124105", // Stool DNA-based colorectal cancer screening (procedure)

  // --- Colonoscopy ---
  "73761001", // Colonoscopy (procedure)
  "174067002", // Colonoscopy (procedure)
  "235150006", // Total colonoscopy (procedure)
  "444783004", // Screening colonoscopy (procedure)

  // --- Flexible sigmoidoscopy (HEDIS-accepted CRC screening modality) ---
  "44441009", // Flexible fiberoptic sigmoidoscopy (procedure)

  // --- CT colonography ---
  "418714002", // Virtual computed tomography colonoscopy (procedure)
];

/**
 * CPT codes for colorectal cancer screening
 * Excludes: interventional/therapeutic colonoscopy add-ons (45380–45398, 44389–44404),
 * stoma surgical closures (44625, 44626), pelvic exenteration (45126), diagnostic-only
 * CT colonography (74261), EGD codes (432xx), sigmoidoscopy with intervention (45331+),
 * Lynch syndrome / MMR gene panels (81288–81319), generic surgical pathology (88305),
 * non-screening FOBT (82272, "performed for other than colorectal neoplasm screening"),
 * quality/registry measure codes (3017F, 0528F, 0529F, G9711), anesthesia consultation
 * (S0285), and all local/custom codes
 */
export const COLORECTAL_CANCER_SCREENING_CPT_CODES = [
  // --- Stool-based tests ---
  "82270", // gFOBT - guaiac fecal occult blood test, colorectal neoplasm screening
  "82274", // FIT - fecal immunochemical test (fecal hemoglobin by immunoassay)
  "81528", // Stool DNA (Cologuard) - 10 DNA markers + fecal hemoglobin
  "0464U", // Stool DNA - methylated markers (LASS4, LRRC4, PPP2R5C) + fecal hemoglobin
  "G0328", // FIT - colorectal cancer screening, fecal occult blood immunoassay (Medicare)
  "G0464", // Stool DNA + fecal occult hemoglobin, colorectal cancer screening (Medicare)

  // --- Colonoscopy ---
  "45378", // Colonoscopy, flexible; diagnostic (base code used for screening indication)
  "G0105", // Colonoscopy screening; individual at high risk (Medicare)
  "G0121", // Colonoscopy screening; individual not meeting high-risk criteria (Medicare)
  "00812", // Anesthesia for lower intestinal endoscopic procedure; screening colonoscopy

  // --- CT colonography ---
  "74263", // CT colonography, screening, including image postprocessing
];
